import { render, staticRenderFns } from "./IpsDropdown.vue?vue&type=template&id=4cc024c2&scoped=true"
import script from "./IpsDropdown.vue?vue&type=script&lang=js"
export * from "./IpsDropdown.vue?vue&type=script&lang=js"
import style0 from "./IpsDropdown.vue?vue&type=style&index=0&id=4cc024c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc024c2",
  null
  
)

export default component.exports